import { resolveRecruitmentPermissions } from "../../services/recruitmentPermissions";
import { useEffect, useState, useMemo } from "react";
import { db, storage } from "../../../../backend/firebaseConfig";
import { collection, getDocs, doc, getDoc, setDoc } from "firebase/firestore";
import "../../../../css/Recruitment/ApplicationSummary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faSpinner,
  faEdit,
  faPrint,
  faFolder,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
  setSelectedUid,
  setApprovedStatus,
  getSelectedUid,
} from "../Utils/UidListener";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import AdvisorFileModal from "./AdvisorFiles";
import Sidebar from "../../../DesignSystem/Sidebar.js";
import { useNavigate } from "react-router-dom";
// import RecruitmentApplicationPDF from "../PrintApplication/PrintApplication.js";
import RecruitmentApplicationPDF from "../PrintApplication/PrintApplicationRefactored.js";
import ReferenceAuthorisationFormPDF from "../PrintApplication/RefAuthForm";
import { pdf } from "@react-pdf/renderer";
import { getDataS1 } from "../../../../backend/Recruitment/Sections/Section1/readDataS1.js";
import { readDataS2 } from "../../../../backend/Recruitment/Sections/Section2/readDataS2.js";
import readDataS3 from "../../../../backend/Recruitment/Sections/Section3/readDataS3.js";
import { readDataS4 } from "../../../../backend/Recruitment/Sections/Section4/readDataS4.js";
import { readDataS5 } from "../../../../backend/Recruitment/Sections/Section5/readDataS5.js";
import { readDataS6 } from "../../../../backend/Recruitment/Sections/Section6/readDataS6.js";
import { readDataS7 } from "../../../../backend/Recruitment/Sections/Section7/readDataS7.js";
import { readDataS8 } from "../../../../backend/Recruitment/Sections/Section8/readDataS8.js";
import { readDataS9 } from "../../../../backend/Recruitment/Sections/Section9/readDataS9.js";
import { readDataS10 } from "../../../../backend/Recruitment/Sections/Section10/readDataS10.js";
import { readDataS11 } from "../../../../backend/Recruitment/Sections/Section11/readDataS11.js";
import UpdateRecruitmentStatus from "./UpdateRecruitmentStatus";
import { useUserPermissions } from "../../../SignIn/UserPermissionsContext.js";
import { Helmet } from "react-helmet-async";
import ButtonGreen from "../../../DesignSystem/Buttons/ButtonGreen.js";
import ButtonSmall from "../../../DesignSystem/Buttons/ButtonSmall.js";
import ButtonYellow from "../../../DesignSystem/Buttons/ButtonYellow.js";
import dayjs from "dayjs";
import WeeklyRecruitmentEmailPreview from "../../Components/RecruitmentUpdate/weeklyRecruitmentUpdate.js";
import SignInButton from "../../../DesignSystem/Buttons/SignInButton";
import SecondaryButton from "../../../DesignSystem/Buttons/SecondaryButton.js";
import Tabs from "../../../DesignSystem/Tabs/Tabs.js";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as FolderIcon } from "../../../../assets/icons/folder.svg";
import { ReactComponent as ViewIcon } from "../../../../assets/icons/view.svg";
import { ReactComponent as PrintIcon } from "../../../../assets/icons/print.svg";
import { ReactComponent as AuditIcon } from "../../../../assets/icons/Audit.svg";
import { ProductionQuantityLimits } from "@mui/icons-material";
import ButtonPrimarySmall from "../../../DesignSystem/Buttons/ButtonPrimarySmall.js";
import ButtonOutlinedRed from "../../../DesignSystem/Buttons/ButtonOutlinedRed.js";
import PrimaryButton from "../../../DesignSystem/Buttons/PrimaryButton.js";
import ButtonOutlinedWithIconSmall from "../../../DesignSystem/Buttons/ButtonOutlinedWithIconSmall.js";
import ConfirmActionModal from "./ConfirmActionModal";
import Pagination from "../../../DesignSystem/Pagination/Pagination.js";
import formatUKPhone from "../../../AdviserSupport/ContactList/HelperFunctions/formatUKPhone.js";
import Breadcrumb from "../../../DesignSystem/Breadcrumb/Breadcrumb";
import { buildRoute } from "../../../../constants/appRoutes.js";
import {
  duplicateApplicationToRecruitment,
  recruitmentPipelinePath,
  saveReferenceConsentFormToRecruitment,
  startContractDrafting,
} from "../../services/recruitmentPipelineService.js";
import { SHOW_CONTRACT_DRAFTING } from "../../Referencing/constants/recruitment.js";

const RECRUITMENT_TAB_STORAGE_KEY = "recruitmentApplications.activeTab";
const RECRUITMENT_PAGE_STORAGE_KEY = "recruitmentApplications.currentPage";
const RECRUITMENT_TABS = new Set([
  "submitted",
  "notSubmitted",
  "isAppointed",
  "notProceedingWith",
]);

const getStoredRecruitmentTab = () => {
  const storedTab = sessionStorage.getItem(RECRUITMENT_TAB_STORAGE_KEY);
  return RECRUITMENT_TABS.has(storedTab) ? storedTab : "submitted";
};

const getStoredRecruitmentPage = () => {
  const storedPage = Number(sessionStorage.getItem(RECRUITMENT_PAGE_STORAGE_KEY));
  return Number.isInteger(storedPage) && storedPage > 0 ? storedPage : 1;
};

const DATA_PATH = (adviserId) =>
  doc(db, "Advisers", adviserId, "Personal Details", "Data");

const ADVISER_DOC = (adviserId) => doc(db, "Advisers", adviserId);

export default function ApplicationsTable() {
  const [applicationsData, setApplicationsData] = useState([]);
  const [selectedUid, setSelectedUidLocal] = useState(null);
  const [files, setFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [downloadingRow, setDownloadingRow] = useState(null);
  const [referencingAdviserId, setReferencingAdviserId] = useState(null);
  const [contractDraftingAdviserId, setContractDraftingAdviserId] =
    useState(null);
  const [updateData, setUpdateData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    action: null,
    adviserId: null,
    adviserName: "",
  });
  const [filterStatus, setFilterStatus] = useState(getStoredRecruitmentTab);
  const { userPermissions } = useUserPermissions();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(getSelectedUid());
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(getStoredRecruitmentPage);
  const [itemsPerPage] = useState(15);

  const handleOpenUpdateForm = (data) => {
    setUpdateData(data);
    setModalOpen(true);
  };

  const handleCloseUpdateForm = () => setModalOpen(false);

  const openConfirm = (action, app) => {
    setConfirmState({
      isOpen: true,
      action,
      adviserId: app.adviserId,
      adviserName: app.name || "Adviser",
    });
  };

  const closeConfirm = () => {
    setConfirmState((prev) => ({ ...prev, isOpen: false }));
  };

  const getConfirmCopy = (action, adviserName) => {
    switch (action) {
      case "APPOINTED":
        return {
          title: `Appoint - ${adviserName}`,
          message: `Are you sure you want to proceed with the appointment for the adviser? ${adviserName}?`,
          confirmLabel: "Appoint",
        };
      case "NOT_PROCEEDING":
        return {
          title: "Not Proceeding With - " + adviserName,
          message: `Are you sure you do not want to proceed with ${adviserName}?`,
          confirmLabel: "Confirm",
        };
      case "MARK_SUBMITTED":
        return {
          title: "Mark Application Submitted",
          message: `Mark ${adviserName} as submitted?`,
          confirmLabel: "Mark Submitted",
        };
      case "MARK_SUBMITTED_AND_NPW":
        return {
          title: `Not Proceeding With - ${adviserName}`,
          message: `Are you sure you don’t want to proceed with the ${adviserName}?`,
          confirmLabel: "Confirm",
        };
      default:
        return {
          title: "Confirm Action",
          message: "Are you sure you want to continue?",
          confirmLabel: "Confirm",
        };
    }
  };

  const handleConfirmAction = async () => {
    const { action, adviserId } = confirmState;
    closeConfirm();

    if (!action || !adviserId) return;

    if (action === "APPOINTED") {
      await handleDecision({ adviserId, nextStatus: "APPOINTED" });
      return;
    }

    if (action === "NOT_PROCEEDING") {
      await handleDecision({ adviserId, nextStatus: "NOT_PROCEEDING" });
      return;
    }

    if (action === "MARK_SUBMITTED") {
      await handleMarkSubmitted(adviserId);
      return;
    }

    if (action === "MARK_SUBMITTED_AND_NPW") {
      await handleMarkSubmitted(adviserId);
      await handleDecision({ adviserId, nextStatus: "NOT_PROCEEDING" });

      setApplicationsData((prev) =>
        prev.map((row) =>
          row.adviserId === adviserId
            ? { ...row, notProceedingWith: true }
            : row,
        ),
      );
    }
  };

  const fetchApplications = async () => {
    try {
      const advisersSnapshot = await getDocs(collection(db, "Advisers"));
      const apps = await Promise.all(
        advisersSnapshot.docs.map(async (adviserDoc) => {
          const a = adviserDoc.data();
          if (!a?.uid) return null;

          const dataSnap = await getDoc(
            DATA_PATH(adviserDoc.id).withConverter(null),
          );
          const data = dataSnap.exists() ? dataSnap.data() : {};
          const recruitmentSnapshot = await getDoc(
            recruitmentPipelinePath(adviserDoc.id),
          );

          const email =
            data?.email ||
            data?.emailAddress ||
            data?.personalEmail ||
            a?.email ||
            null;

          return {
            adviserId: adviserDoc.id,
            uid: a.uid,
            isAR: a.isAR ?? data?.recruitmentUpdates?.[0]?.isAR ?? null,
            status: resolveRecruitmentPermissions(a, data?.recruitmentUpdates?.[0]),
            name:
              data?.recruitmentUpdates?.[0]?.applicantName ||
              a.displayName ||
              "Unknown",
            emailAddress: email,
            mobileTelephone: data?.mobileTelephone || "",
            approved: data?.recruitmentApplicationApproved ?? false,
            hasPersonalDataDoc: dataSnap.exists(),
            recruitmentApplicationSubmittedAt:
              data?.recruitmentApplicationSubmittedAt || null,
            recruitmentUpdates: Array.isArray(data?.recruitmentUpdates)
              ? data.recruitmentUpdates
              : [],
            inReferencingPipeline: recruitmentSnapshot.exists(),
            isContractDrafting:
              recruitmentSnapshot.data()?.contractDraftingStatus ===
                "DRAFTING" ||
              recruitmentSnapshot.data()?.isContractDrafting === true,
            // status flags on Advisers doc
            isAppointed: a.isAppointed || false,
            appointedAt: a.appointedAt || null,
            notProceedingWith: a.notProceedingWith || false,
          };
        }),
      );

      const list = apps.filter(Boolean);
      setApplicationsData(list);
    } catch (err) {
      // console.error("Error fetching applications:", err);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleViewClick = (uid, approveStatus) => {
    setSelectedUid(uid);
    setApprovedStatus(approveStatus);
    navigate(`/Applications/${uid}`);
  };

  const handleBeginReferencing = async (app) => {
    const isEligibleForReferencing =
      filterStatus === "submitted" &&
      Boolean(app?.recruitmentApplicationSubmittedAt) &&
      app?.isAppointed !== true &&
      app?.approved !== true &&
      app?.notProceedingWith !== true &&
      app?.decision?.status !== "APPOINTED" &&
      app?.decision?.status !== "NOT_PROCEEDING";

    if (!app?.adviserId || referencingAdviserId || !isEligibleForReferencing) {
      return;
    }

    setReferencingAdviserId(app.adviserId);
    try {
      await duplicateApplicationToRecruitment(app.adviserId, app.uid);
      const declarationSnapshot = await getDoc(
        doc(
          db,
          "Advisers",
          app.uid,
          "Application Details",
          "Declaration",
        ),
      );
      const consentFormBlob = await pdf(
        <ReferenceAuthorisationFormPDF
          userId={app.uid}
          section11={
            declarationSnapshot.exists() ? declarationSnapshot.data() : {}
          }
        />,
      ).toBlob();
      await saveReferenceConsentFormToRecruitment(
        app.adviserId,
        consentFormBlob,
      );
      setApplicationsData((currentApplications) =>
        currentApplications.map((application) =>
          application.adviserId === app.adviserId
            ? { ...application, inReferencingPipeline: true }
            : application,
        ),
      );
    } catch (error) {
      alert(
        error?.message ||
          "The application could not be added to the referencing pipeline.",
      );
    } finally {
      setReferencingAdviserId(null);
    }
  };

  const handleDraftContract = async (app) => {
    if (!app?.adviserId || contractDraftingAdviserId) return;

    if (app.isContractDrafting) {
      navigate(buildRoute.recruitmentContractDrafting(app.adviserId));
      return;
    }

    setContractDraftingAdviserId(app.adviserId);
    try {
      await startContractDrafting(app.adviserId);
      setApplicationsData((currentApplications) =>
        currentApplications.map((application) =>
          application.adviserId === app.adviserId
            ? { ...application, isContractDrafting: true }
            : application,
        ),
      );
      navigate(buildRoute.recruitmentContractDrafting(app.adviserId));
    } catch (error) {
      alert(
        error?.message ||
          "Contract drafting could not be started. Please try again.",
      );
    } finally {
      setContractDraftingAdviserId(null);
    }
  };

  const handleViewFiles = async (uid) => {
    setSelectedUidLocal(uid);
    await fetchFiles(uid);
    setIsModalOpen(true);
  };

  const fetchFiles = async (uid) => {
    const listRef = ref(storage, `uploads/${uid}/`);
    const fileUrls = [];

    const fetchAllFiles = async (r) => {
      const res = await listAll(r);
      const urls = await Promise.all(
        res.items.map(async (item) => {
          const url = await getDownloadURL(item);
          return { name: item.name, url };
        }),
      );
      fileUrls.push(...urls);
      for (const prefix of res.prefixes) {
        await fetchAllFiles(prefix);
      }
    };

    try {
      await fetchAllFiles(listRef);
      setFiles(fileUrls);
    } catch (error) {
      // console.error("Error fetching files:", error);
    }
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem("selectedUid");
    };
  }, []);

  const handleDownloadPDF = async (uid) => {
    try {
      setDownloadingRow(uid);
      const [
        section1,
        section2,
        section3,
        section4,
        section5,
        section6,
        section7,
        section8,
        section9,
        section10,
        section11,
      ] = await Promise.all([
        getDataS1(),
        readDataS2(),
        readDataS3(),
        readDataS4(),
        readDataS5(),
        readDataS6(),
        readDataS7(),
        readDataS8(),
        readDataS9(),
        readDataS10(),
        readDataS11(),
      ]);

      const pdfDoc = (
        <RecruitmentApplicationPDF
          userId={userId}
          section1={section1}
          section2={section2}
          section3={section3}
          section4={section4}
          section5={section5}
          section6={section6}
          section7={section7}
          section8={section8}
          section9={section9}
          section10={section10}
          section11={section11}
        />
      );

      const referenceAuthorisationForm = (
        <ReferenceAuthorisationFormPDF userId={userId} section11={section11} />
      );

      const blob = await pdf(pdfDoc).toBlob();
      const blob2 = await pdf(referenceAuthorisationForm).toBlob();

      const a1 = document.createElement("a");
      a1.href = URL.createObjectURL(blob);
      a1.download = "Recruitment Application.pdf";
      a1.click();

      const a2 = document.createElement("a");
      a2.href = URL.createObjectURL(blob2);
      a2.download = "Reference Authorisation Form.pdf";
      a2.click();
    } catch (error) {
      // console.error("Error generating PDF:", error);
    } finally {
      setDownloadingRow(null);
    }
  };

  const parseDate = (timestamp) =>
    timestamp?.toDate ? timestamp.toDate() : null;

  // ---- Approve / Decline logic (writes both a decision + flags + audit trail) ----
  const handleDecision = async ({ adviserId, nextStatus }) => {
    try {
      if (
        !userPermissions?.includes("Compliance") &&
        !userPermissions?.includes("Recruitment")
      ) {
        alert("You don't have permission to take this action.");
        return;
      }

      let reason = "";

      // Flip simple flags on Advisers doc (so your Status column & filters work)
      await setDoc(
        ADVISER_DOC(adviserId),
        {
          isAppointed: nextStatus === "APPOINTED",
          notProceedingWith: nextStatus === "NOT_PROCEEDING",
          appointedAt:
            nextStatus === "APPOINTED" ? new Date().toISOString() : null,
          npwAt:
            nextStatus === "NOT_PROCEEDING" ? new Date().toISOString() : null,
        },
        { merge: true },
      );

      // Optimistic UI update
      setApplicationsData((prev) =>
        prev.map((row) =>
          row.adviserId === adviserId
            ? {
                ...row,
                isAppointed: nextStatus === "APPOINTED",
                notProceedingWith: nextStatus === "NOT_PROCEEDING",
              }
            : row,
        ),
      );
    } catch (e) {
      // console.error("Failed to update decision:", e);
      alert("Sorry, that didn’t work. Please try again.");
    }
  };

  // ---- Filters (fixed wrong values for 'Appointed' & 'Not Proceeding') ----
  const filteredAndSorted = useMemo(() => {
    const parseD = (d) => {
      if (!d) return null;
      // Firestore Timestamp
      if (d?.toDate) return dayjs(d.toDate());
      // ISO string / Date / other parseable string
      if (dayjs(d).isValid()) return dayjs(d);
      return null;
    };

    let filtered = [...applicationsData];

    switch (filterStatus) {
      case "submitted": {
        filtered = filtered.filter((app) => {
          const hasSubmission = !!app.recruitmentApplicationSubmittedAt;
          const isApproved =
            app.isAppointed === true ||
            app.approved === true ||
            app.decision?.status === "APPOINTED";
          const notProceedingWith =
            app.notProceedingWith === true ||
            app.decision?.status === "NOT_PROCEEDING";
          return hasSubmission && !(isApproved || notProceedingWith);
        });
        break;
      }
      case "notSubmitted":
        filtered = filtered.filter(
          (app) => !app.recruitmentApplicationSubmittedAt,
        );
        break;
      case "isAppointed":
        filtered = filtered.filter((app) => app.isAppointed === true);
        break;
      case "notProceedingWith":
        filtered = filtered.filter(
          (app) =>
            app.notProceedingWith === true &&
            app.recruitmentApplicationSubmittedAt,
        );
        break;
      case "all":
      default:
        break;
    }

    // Decide which date to sort by based on the active filter
    const getSortDate = (app) => {
      if (filterStatus === "isAppointed") {
        // <-- Sort appointed list by appointedAt
        return parseD(app.appointedAt);
      }
      if (filterStatus === "notProceedingWith") {
        // Optional: if you later store npwAt, prefer it; fallback to submission
        return (
          parseD(app.npwAt) || parseD(app.recruitmentApplicationSubmittedAt)
        );
      }
      // Default: sort by submission timestamp
      return parseD(app.recruitmentApplicationSubmittedAt);
    };

    return filtered.sort((a, b) => {
      const da = getSortDate(a);
      const db = getSortDate(b);

      if (da && db) return db.valueOf() - da.valueOf(); // newest first
      if (!da && db) return 1;
      if (da && !db) return -1;
      return 0;
    });
  }, [applicationsData, filterStatus]);

  const selectedApplication = applicationsData.find(
    (app) => app.uid === selectedUid,
  );

  // Calculate counts for each filter status
  const tabCounts = useMemo(() => {
    const isSubmittedPipelineApplication = (app) => {
      const isApproved =
        app.isAppointed === true ||
        app.approved === true ||
        app.decision?.status === "APPOINTED";
      const isNotProceeding =
        app.notProceedingWith === true ||
        app.decision?.status === "NOT_PROCEEDING";

      return Boolean(app.recruitmentApplicationSubmittedAt) &&
        !isApproved &&
        !isNotProceeding;
    };

    return {
      submitted: applicationsData.filter(isSubmittedPipelineApplication).length,
      notSubmitted: applicationsData.filter(
        (app) => !app.recruitmentApplicationSubmittedAt,
      ).length,
      isAppointed: applicationsData.filter(
        (app) => app.isAppointed === true,
      ).length,
      notProceedingWith: applicationsData.filter(
        (app) =>
          app.notProceedingWith === true &&
          app.recruitmentApplicationSubmittedAt,
      ).length,
    };
  }, [applicationsData]);

  // Preserve the selected tab and page while viewing a referencing record.
  useEffect(() => {
    sessionStorage.setItem(RECRUITMENT_TAB_STORAGE_KEY, filterStatus);
  }, [filterStatus]);

  useEffect(() => {
    sessionStorage.setItem(
      RECRUITMENT_PAGE_STORAGE_KEY,
      String(currentPage),
    );
  }, [currentPage]);

  const handleTabChange = (nextTab) => {
    setFilterStatus(nextTab);
    setCurrentPage(1);
  };

  // Calculate pagination
  const totalPages = Math.ceil(filteredAndSorted.length / itemsPerPage);
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredAndSorted.slice(startIndex, endIndex);
  }, [filteredAndSorted, currentPage, itemsPerPage]);

  // Calculate total advisers in recruitment pipeline (all statuses)
  const totalAdvisersInRecruitment = useMemo(() => {
    return applicationsData.filter(
      (app) =>
        app.recruitmentApplicationSubmittedAt ||
        app.isAppointed === true ||
        app.notProceedingWith === true,
    ).length;
  }, [applicationsData]);

  const handleMarkSubmitted = async (adviserId) => {
    try {
      await setDoc(
        DATA_PATH(adviserId),
        {
          recruitmentApplicationSubmittedAt: new Date().toISOString(),
          recruitmentApplication: true,
        },
        { merge: true },
      );

      await setDoc(
        ADVISER_DOC(adviserId),
        {
          isAppointed: false,
          notProceedingWith: false,
        },
        { merge: true },
      );

      // Optimistic UI: set timestamp AND clear flags locally
      setApplicationsData((prev) =>
        prev.map((row) =>
          row.adviserId === adviserId
            ? {
                ...row,
                recruitmentApplicationSubmittedAt: new Date(), // simpler than fake .toDate()
                recruitmentApplication: true,
                isAppointed: false,
                notProceedingWith: false,
                // (optional) if you still have decision objects affecting filters, clear it:
                // decision: row.decision ? { ...row.decision, status: undefined } : row.decision,
              }
            : row,
        ),
      );

      // (optional) await fetchApplications(); // to sync exact server timestamp
    } catch (e) {
      // console.error("Failed to mark as submitted:", e);
      alert("Sorry, that didn’t work. Please try again.");
    }
  };

  return (
    <div className="main-content">
      <Helmet>
        <title>Recruitment Applications</title>
        <meta
          name="description"
          content="View and manage recruitment applications, including file uploads, approvals, declines, and updates."
        />
      </Helmet>

      <Sidebar isSetExpanded={true} />

      <div className="applications-table">
        <Breadcrumb
          items={[
            {
              label: "Compliance",
              to: "/Department/Compliance",
            },
            { label: "Recruitment Applications" },
          ]}
        />
        <>
          <div className="space-between-row">
            <h3>Recruitment Applications</h3>
            <SecondaryButton
              label={"Recruitment Update"}
              onClick={() => setIsEmailModalOpen(true)}
            />
          </div>

          <div className="TabsContainer">
            <Tabs
              noShadow={true}
              tabs={[
                {
                  id: "submitted",
                  label: "Submitted",
                  count: tabCounts.submitted,
                },
                {
                  id: "notSubmitted",
                  label: "Not Yet Submitted",
                  count: tabCounts.notSubmitted,
                },
                {
                  id: "isAppointed",
                  label: "Appointed",
                  count: tabCounts.isAppointed,
                },
                {
                  id: "notProceedingWith",
                  label: "Not Proceeding With",
                  count: tabCounts.notProceedingWith,
                },
              ]}
              activeTab={filterStatus}
              onTabChange={handleTabChange}
            />
          </div>
          {/* {filterStatus === "submitted" && (
            <div
              className="FP_Content_Semibold text-black"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              Total number of applications in the Recruitment Pipeline:{" "}
              <strong>{filteredAndSorted.length}</strong>
            </div>
          )} */}
          <table>
            <thead>
              <tr>
                {/* <th>
                  <div className="Content"></div>
                </th> */}
                <th>
                  <div className="Label-Medium">ADVISER DETAILS</div>
                </th>

                <th>
                  <div className="Label-Medium">Latest Update</div>
                </th>
                <th>
                  <div className="Label-Medium">Actions</div>
                </th>

                <th style={{ minWidth: "155px" }}>
                  <div className="Label-Medium">
                    {filterStatus === "isAppointed"
                      ? "Appointed On"
                      : "Decision"}
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((app, index) => (
                <tr key={app.adviserId ?? index}>
                  {/* <td>
                    <div className="Content">{index + 1}</div>
                  </td> */}

                  <td>
                    <div className="flex-start-row">
                      <div className="FP_Content_Semibold text-black">
                        {(currentPage - 1) * itemsPerPage + index + 1}.
                      </div>
                      <div>
                        <div className="FP_Content_Semibold text-black">{app.name}</div>
                        <div className="Content-Small">
                          {app.recruitmentApplicationSubmittedAt?.toDate
                            ? dayjs(
                                app.recruitmentApplicationSubmittedAt.toDate(),
                              ).format("DD/MM/YYYY, HH:mm:ss")
                            : app.recruitmentApplicationSubmittedAt &&
                                dayjs(
                                  app.recruitmentApplicationSubmittedAt,
                                ).isValid()
                              ? dayjs(
                                  app.recruitmentApplicationSubmittedAt,
                                ).format("DD/MM/YYYY, HH:mm:ss")
                              : "Not yet submitted."}
                        </div>
                        <div className="vertical-spacer" />
                        <div className="vertical-spacer" />
                        <div className="adviser-Contact-Details">
                          <div className="adviser-Contact-Details">
                            {app.mobileTelephone && (
                              <a
                                href={`tel:+${app.mobileTelephone}`}
                                className="Content-Small"
                              >
                                {formatUKPhone(app.mobileTelephone)}
                                {/* <div className="Content-Small">
                                </div> */}
                              </a>
                            )}
                          </div>

                          <div className="Content-Small">
                            <a href={`mailto:${app.emailAddress}`}>
                              {app.emailAddress}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* <td>
                    <div className="Content">
                      {app.recruitmentApplicationSubmittedAt?.toDate
                        ? app.recruitmentApplicationSubmittedAt
                            .toDate()
                            .toLocaleString()
                        : "Not yet submitted."}
                    </div>
                  </td> */}

                  <td>
                    <div className="update-cell">
                      <div className="flex-start-column">
                        {app.recruitmentUpdates?.[0]?.source && (
                          <div className="FP_Content_Semibold text-black">
                            Source:{" "}
                            <span className="Content-Small">
                              {app.recruitmentUpdates?.[0]?.source || "N/A"}
                            </span>
                          </div>
                        )}
                        {app.status?.length > 0 && (
                          <div className="FP_Content_Semibold text-black">
                            Permission:{" "}
                            <span className="Content-Small">
                              {app.status.join(", ")}
                            </span>
                          </div>
                        )}
                        {app.recruitmentUpdates?.[0]?.arTsName && (
                          <div className="FP_Content_Semibold text-black">
                            {app.isAR === true ? "AR Name:" : app.isAR === false ? "TS Name:" : "AR/TS Name:"}{" "}
                            <span className="Content-Small">
                              {app.recruitmentUpdates?.[0]?.arTsName || ""}
                            </span>
                          </div>
                        )}
                        {!app.recruitmentUpdates?.[0]?.arTsName &&
                          typeof app.isAR === "boolean" && (
                          <div className="FP_Content_Semibold text-black">
                            Joining as:{" "}
                            <span className="Content-Small">
                              {app.isAR === true ? "AR" : app.isAR === false ? "TS" : ""}
                            </span>
                          </div>
                        )}
                        {(app.recruitmentUpdates?.[0]?.description ||
                          app.recruitmentUpdates?.[0]?.update) && (
                          <div className="FP_Content_Semibold text-black">
                            Notes:{" "}
                            <span className="Content-Small">
                              {app.recruitmentUpdates?.[0]?.description ||
                                app.recruitmentUpdates?.[0]?.update ||
                                "No updates available."}
                            </span>
                          </div>
                        )}
                      </div>
                      <EditIcon
                        className="notes-icon"
                        onClick={() =>
                          handleOpenUpdateForm({
                            advisorId: app.adviserId,
                            advisor: app.name,
                            isAR: app.isAR ?? null,
                            status: app.status,
                            applicantName:
                              app.recruitmentUpdates?.[0]?.applicantName ||
                              app.name ||
                              "",
                            source: app.recruitmentUpdates?.[0]?.source || "",
                            arTsName:
                              app.recruitmentUpdates?.[0]?.arTsName || "",
                            lastContacted:
                              app.recruitmentUpdates?.[0]?.lastContacted || "",
                            appointmentData:
                              app.recruitmentUpdates?.[0]?.appointmentData ||
                              "",
                            company: app.recruitmentUpdates?.[0]?.company || "",
                            lastUpdated:
                              app.recruitmentUpdates?.[0]?.lastUpdated?.toDate?.() ||
                              app.recruitmentUpdates?.[0]?.lastUpdated ||
                              "",
                            description:
                              app.recruitmentUpdates?.[0]?.description ||
                              app.recruitmentUpdates?.[0]?.update ||
                              "No updates available.",
                            permission:
                              app.recruitmentUpdates?.[0]?.permission || "",
                          })
                        }
                      />
                    </div>
                  </td>

                  <td>
                    <div className="icon-container">
                      <ButtonOutlinedWithIconSmall
                        buttonText="View Uploaded Files"
                        icon={<FolderIcon className="files-icon" />}
                        //   onClick={() => {
                        // <FolderIcon
                        // icon={faFolder}
                        onClick={() => {
                          setSelectedUid(app.uid);
                          handleViewFiles(app.uid);
                        }}
                        title="View Files"
                        className="files-icon"
                      />

                      <ButtonOutlinedWithIconSmall
                        buttonText="View Application"
                        icon={<ViewIcon className="view-icon" />}
                        onClick={() => handleViewClick(app.uid, app.approved)}
                        className="view-icon"
                        title="View Application"
                      />
                      <ButtonOutlinedWithIconSmall
                        buttonText="Print Application"
                        icon={
                          downloadingRow === app.uid ? (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spinning
                              className="print-icon"
                            />
                          ) : (
                            <PrintIcon className="print-icon" />
                          )
                        }
                        spin={downloadingRow === app.uid}
                        onClick={() => {
                          setSelectedUid(app.uid);
                          handleDownloadPDF(app.uid);
                        }}
                        title="Print Application"
                        className="print-icon"
                        style={{
                          cursor:
                            downloadingRow === app.uid
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />

                      {app.inReferencingPipeline && (
                        <>
                          <ButtonOutlinedWithIconSmall
                            icon={<AuditIcon className="referencing-icon" />}
                            onClick={() =>
                              navigate(
                                buildRoute.recruitmentReferencing(
                                  app.adviserId,
                                ),
                              )
                            }
                            title="Referencing Pipeline"
                            className="referencing-icon"
                            buttonText="Referencing Pipeline"
                          />
                          {SHOW_CONTRACT_DRAFTING && (
                            <ButtonOutlinedWithIconSmall
                              icon={<AuditIcon className="referencing-icon" />}
                              onClick={() => handleDraftContract(app)}
                              disabled={
                                filterStatus !== "submitted" ||
                                contractDraftingAdviserId !== null
                              }
                              buttonText={
                                contractDraftingAdviserId === app.adviserId
                                  ? "Starting..."
                                  : app.isContractDrafting
                                    ? "Contract Drafting"
                                    : "Draft Contract"
                              }
                            />
                          )}
                        </>
                      )}
                      {/* Approve / Decline */}
                    </div>
                  </td>
                  {filterStatus !== "notSubmitted" && (
                    <td>
                      <div className="Content">
                        {app.isAppointed
                          ? app.appointedAt
                            ? `${dayjs(app.appointedAt).format("DD/MM/YYYY")}`
                            : ""
                          : app.notProceedingWith
                            ? "Not Proceeding"
                            : ""}
                        {app.recruitmentApplicationSubmittedAt && (
                          <div className="decision-buttons">
                            {filterStatus === "submitted" &&
                              !app.inReferencingPipeline && (
                              <SecondaryButton
                                label={
                                  referencingAdviserId === app.adviserId ? (
                                    <>
                                      <FontAwesomeIcon icon={faSpinner} spin />{" "}
                                      Loading...
                                    </>
                                  ) : (
                                    "Begin Referencing"
                                  )
                                }
                                onClick={() => handleBeginReferencing(app)}
                                disabled={referencingAdviserId !== null}
                              />
                              )}
                            {!app.isAppointed && !app.notProceedingWith && (
                              <>
                                <ButtonPrimarySmall
                                  buttonText="Appoint"
                                  onClick={() => openConfirm("APPOINTED", app)}
                                />
                                <ButtonOutlinedRed
                                  buttonText="NPW"
                                  onClick={() =>
                                    openConfirm("NOT_PROCEEDING", app)
                                  }
                                  disabled={app.notProceedingWith}
                                />
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </td>
                  )}
                  {filterStatus === "notSubmitted" && (
                    <td>
                      <div className="decision-buttons">
                        <PrimaryButton
                          label="Mark Submitted"
                          onClick={() => openConfirm("MARK_SUBMITTED", app)}
                        />
                        <ButtonOutlinedRed
                          buttonText="NPW"
                          onClick={async () => {
                            openConfirm("MARK_SUBMITTED_AND_NPW", app);
                          }}
                          disabled={app.notProceedingWith}
                        />
                      </div>
                    </td>
                  )}
                </tr>
              ))}
              {isEmailModalOpen && (
                <WeeklyRecruitmentEmailPreview
                  apps={applicationsData}
                  onClose={() => setIsEmailModalOpen(false)}
                  // onSent={() => ...optional toast...}
                />
              )}
              <AdvisorFileModal
                uid={selectedUid}
                files={files}
                name={selectedApplication?.name}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onFileUpload={(file) => setFiles((prev) => [...prev, file])}
              />
              <UpdateRecruitmentStatus
                isOpen={modalOpen}
                onClose={handleCloseUpdateForm}
                updateData={updateData}
                setUpdateData={setUpdateData}
                advisorId={updateData.advisorId}
                onSaved={fetchApplications}
              />
              <ConfirmActionModal
                isOpen={confirmState.isOpen}
                onCancel={closeConfirm}
                onConfirm={handleConfirmAction}
                {...getConfirmCopy(
                  confirmState.action,
                  confirmState.adviserName,
                )}
              />
            </tbody>
          </table>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </>
      </div>
    </div>
  );
}
